import React, { FC } from 'react';

import { styled } from '@mui/material';

import { H4 } from '~/components/UI/Texts';
import useTenantTranslation from '~/hooks/useTenantTranslation';
import { TINY_MARGIN_PX } from '~/theme';
import AnimatedCheckmark from '~/ui/components/AnimatedCheckmark/AnimatedCheckmark';

type StatusDescriptionProps = {
  isCorrect?: boolean;
  className?: string;
};

const StatusDescription: FC<StatusDescriptionProps> = ({ className, isCorrect }) => {
  const { t } = useTenantTranslation();

  return (
    <Wrapper isCorrect={isCorrect} className={className} data-testid="resultFeedback">
      <StyledAnimatedCheckmark noBackground={true} correct={isCorrect} />
      <Text data-testid="resultCaption">
        {t(isCorrect ? 'page.test.yourAnswerIsCorrect' : 'page.test.yourAnswerIsWrong')}
      </Text>
    </Wrapper>
  );
};

export default StatusDescription;

const Wrapper = styled('div', { shouldForwardProp: (propName) => propName !== 'isCorrect' })<{
  isCorrect?: boolean;
}>`
  display: flex;
  gap: ${TINY_MARGIN_PX};
  align-items: center;
  justify-content: center;
  color: ${({ theme, isCorrect }) =>
    isCorrect ? theme.palette.common.green : theme.palette.common.status.error};
`;
const Text = styled(H4)`
  color: inherit;
`;
const StyledAnimatedCheckmark = styled(AnimatedCheckmark)`
  width: 32px;
  height: 32px;
`;
